import apiClient from "@/libs/axios";
// import store from "@/state/store";
import router from "@/router";

export const state = {
    data: [],
    details: null,
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    setDetails: (state, data) => {
        state.details = data.result;
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, is_approved: data.is_approved} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async get({ commit }, data) {

        const filters = window.mapFilterData(data);

        await apiClient
            .get(`api/v1/ad-banners${filters}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async toggle({ commit }, data) {
        await apiClient
            .patch(`api/v1/ad-banners/toggle`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data.result);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async create({ commit }, data) {
        console.log(data);
        // data = { vendor_id: store.state.profile.profile.basic.vendor.id, ...data };
        console.log(data)
        await apiClient
            .post(`api/v1/ad-banners/store`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 201) {
                    commit('updateData', response.data);
                    router.push({ name: "my-services" })
                }
            })
            .catch(error => {
                // this.toast.add({ severity: "error", summary: "Success", detail: error, life: 3000 }); // not working
                throw error;
            },);

    },
    async details({ commit }, data) {
        await apiClient
            .get(`api/v1/ad-banners/show?id=${data.id}`)
            .then(response => {
                console.log(response)
                if (response.status === 200) {
                    commit('setDetails', response.data)
                }
            })
            .catch(error => {
                throw error;
            })
    },
    async update({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .patch(`api/v1/ad-banners/update`, data)
            .then(() => {
                commit('app/loadingFinish', null, {root: true});
                // commit('updateData', response.result)
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            })
    },

    async delete({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .delete(`api/v1/ad-banners/delete?id=${data.id}`)
            .then(response => {
                console.log(response);
                commit('deleteItem', data.id);
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            });
    },
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getDetails(state) {
        return state.details;
    },
    getTotal(state) {
        return state.total;
    },
};
